import * as React from 'react';
import { SVGProps } from 'react';

const IconCardsSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.5 1.5h4v4h-4v-4zm0 5h4v4h-4v-4zm5-5h4v4h-4v-4zm0 5h4v4h-4v-4z" />
  </svg>
);
export default IconCardsSizeXs;
